function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 3c4.732 0 8.689 1.565 8.983 4.021a.726.726 0 0 1 .01.067l.007.117v10l-.006.101v.014c-.136 1.765-2.5 2.984-5.77 3.459l-.555.072c-.75.088-1.542.137-2.36.147L12 21c-.928 0-1.825-.05-2.669-.149l-.555-.072c-3.265-.474-5.625-1.69-5.769-3.449L3 17.205v-10c0-.063.006-.124.017-.184C3.31 4.565 7.267 3 12 3zm0 13.421c-2.82 0-5.347-.467-7-1.312v2.049c0 .302.524.666 1.41.99l.35.12c.182.059.377.116.583.17l.426.105c.366.085.761.161 1.18.226l.513.072a20.26 20.26 0 0 0 5.076 0l.513-.072c.419-.065.814-.141 1.18-.226l.426-.105c.206-.054.4-.111.583-.17l.35-.12c.83-.304 1.343-.643 1.404-.933l.006-.057.001-2.05c-1.653.846-4.18 1.313-7.001 1.313zm7-6.301c-1.658.96-4.192 1.512-7 1.512-2.807 0-5.341-.551-7-1.512v2.459c0 .396.903.9 2.343 1.28l.426.105c.366.085.761.161 1.18.226l.513.072a20.26 20.26 0 0 0 5.076 0l.513-.072c.419-.065.814-.141 1.18-.226l.426-.105c1.372-.362 2.256-.836 2.337-1.223L19 12.58v-2.46zM12 5C8.083 5 5 6.278 5 7.316c0 1.038 3.083 2.316 7 2.316s7-1.278 7-2.316C19 6.278 15.917 5 12 5z",
  fill: "#323C47",
  fillRule: "nonzero"
});

var Svg8BaseBackend = function Svg8BaseBackend(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/8base-backend.0002024e.svg";
export { Svg8BaseBackend as ReactComponent };